import React, { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import useApi from "../../CustomHooks/useApi";

const GREETING = "👋 Hello Retailer! Welcome back. Have a wonderful and successful day! 🚀";

const TickerBanner = () => {
  const { callApi: fetchTicker } = useApi("/ticker/active", "GET");
  const [message, setMessage] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetchTicker();
        if (res && res.active && res.message) {
          setMessage(res.message);
        }
      } catch {
        // 204 No Content or network error — fall back to greeting
      } finally {
        setReady(true);
      }
    };
    load();
  }, []);

  if (!ready) return null;

  const displayText = message || GREETING;
  const isGreeting = !message;

  return (
    <div className="w-full flex items-center h-12 overflow-hidden bg-gradient-to-r from-[#0A2540] to-[#0F3057] border-b border-white/10">
      {/* Label chip */}
      <div className="shrink-0 flex items-center gap-1.5 px-4 h-full border-r border-white/20 bg-amber-500/10">
        <Megaphone className="w-3.5 h-3.5 text-amber-300" />
        <span className="text-[11px] font-bold text-amber-300 uppercase tracking-widest whitespace-nowrap">
          {isGreeting ? "Hello" : "Notice"}
        </span>
      </div>

      {/* Scrolling text */}
      <div className="flex-1 overflow-hidden relative h-full flex items-center">
        <span className="ticker-text absolute whitespace-nowrap text-amber-300 font-semibold tracking-wide" style={{ fontSize: "18px" }}>
          {displayText}
        </span>
      </div>

      <style>{`
        @keyframes ticker-scroll {
          0%   { transform: translateX(100vw); }
          100% { transform: translateX(-100%); }
        }
        .ticker-text {
          animation: ticker-scroll 60s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default TickerBanner;
